
import { defineComponent } from "vue"
import MatchPoolsStats from "@/components/match_pools/Stats.vue"

export default defineComponent({
  components: {
    MatchPoolsStats
  }
})
